import React from "react";
import Routing from "./routing/Routing";
import { LanguageProvider } from "./pages/LanguageContext";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  return (
    <LanguageProvider>
      <ToastContainer theme="colored" position="top-center" autoClose={3000} />
      <Routing />
    </LanguageProvider>
  );
};

export default App;
